var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increment-box-wrap"},[_c('img',{staticClass:"increment-bg",attrs:{"src":_vm.bgImg,"alt":"发照片"},on:{"click":_vm.handleSendPhoto}})])}
var staticRenderFns = []

export { render, staticRenderFns }